import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  CardMedia,
  Typography,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { Hydrator } from '@thd-olt-component-react/hydrator';

const TRACKING_PARAM = '?emt=ppspd_prorewards_2508';

export function ProRewardItem({ title, imageUrl, ctaUrl }) {
  const renderTitle = () => title.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <div className="sui-flex sui-flex-col sui-items-center sui-text-center sui-mb-4">
      <Hydrator id="pro-reward-image" scrollBuffer={300}>
        <CardMedia
          src={imageUrl}
          alt={title}
          width={48}
          height={48}
          loading="lazy"
        />
      </Hydrator>

      <div className="sui-h-14 sui-flex sui-items-center sui-justify-center sui-mt-2">
        <Typography
          variant="h3"
          align="center"
          className="sui-break-words sui-max-w-md "
        >
          {renderTitle()}
        </Typography>
      </div>

      <CardActions className="sui-mt-2">
        <a
          href={`${ctaUrl}${TRACKING_PARAM}`}
          className="hover:sui-no-underline sui-w-full"
        >
          <Button fullWidth variant="text">View Details</Button>
        </a>
      </CardActions>
    </div>
  );
}

ProRewardItem.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
};
